import { PERMISSIONS } from 'consts/permission-maps';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import PropTypes from 'prop-types';

const getRole = () => UserSessionDataHandler.getUserDataObject().group;

const hasPermission = ({ permissions, scopes }) =>
  scopes.some(s => permissions.includes(s));

export default function PermissionsGate({ children, scopes = [] }) {
  if (!children) return;
  let permissions = [];

  const roles = getRole();
  roles.forEach(role => {
    permissions = [...PERMISSIONS[role], ...permissions];
  });

  return hasPermission({ permissions, scopes }) ? children : null;
}

PermissionsGate.propTypes = {
  children: PropTypes.node.isRequired,
  scopes: PropTypes.array,
};
